/**
 * TopBarContainer component.
 */
import Colors from '@shared/assets/style/default/color';
import DeviceConfig from '@devices/config';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Props for the top bar container.
 */
interface Props {
  display: boolean;
}

/**
 * TopBarContainer Component that displays the top bar container.
 */
const TopBarContainer = styled.div.attrs(() => ({
  id: 'topBarContainer',
}))<Props>`
  color: ${Colors['text']};
  display: flex;
  filter: ${!DeviceConfig.capabilities.disableAnimations
    ? `drop-shadow(${0 * Screen.widthRatio}px ${0 * Screen.widthRatio}px ${
        4 * Screen.widthRatio
      }px #000000);`
    : ''};
  font-family: ${Fonts['regular']};
  font-size: ${30 * Screen.widthRatio}px;
  height: ${40 * Screen.widthRatio}px;
  justify-content: space-around;
  padding: ${10 * Screen.widthRatio}px ${24 * Screen.widthRatio}px;
  position: absolute;
  right: ${40 * Screen.widthRatio}px;
  top: ${32 * Screen.widthRatio}px;
  width: auto;
  z-index: 50; // Place top bar above the content container but below the player
`;

export default withOpacity(TopBarContainer);
